/**
 * One label/value row of a read-only card — the shape both technician-facing screens use.
 *
 * Extracted the day it had a second caller, not before: the profile's identity card and the
 * request detail's « Intervention » block were byte-identical but for the truncation, which is the
 * kind of pair that drifts one class at a time.
 */
const InfoRow = ({
  label,
  value,
  truncate = false,
}: {
  label: string;
  value: string;
  /** On for a value that must stay on one line (an email, a list of codes), off for an address. */
  truncate?: boolean;
}) => (
  <div className="flex items-baseline justify-between gap-4 border-t border-zinc-200 px-4 py-2.5 dark:border-zinc-800">
    <span className="shrink-0 text-xs text-zinc-500 dark:text-zinc-400">{label}</span>
    <span
      className={`min-w-0 text-right text-[13px] font-medium text-zinc-900 dark:text-zinc-50${
        truncate ? ' truncate' : ''
      }`}
    >
      {value}
    </span>
  </div>
);

export default InfoRow;
